import { render, staticRenderFns } from "./OTaiwan97.vue?vue&type=template&id=3c17b5f2&"
import script from "./OTaiwan97.vue?vue&type=script&lang=js&"
export * from "./OTaiwan97.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports